import { distinctUntilChanged, Subscription } from 'rxjs';
import { Component, OnDestroy, Output } from '@angular/core';
import { ButtonsCard, LocationCard } from '../../shared/models/components-general/card.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ServicesTable } from '../services-table/services-table';
import { CardLocations } from '../card-locations/card-locations';
import { LocationDetail } from '../location-detail/location-detail';
import { MapGeneral } from '../../shared/components-generals/map-general/map-general';
import { MatTableDataSource } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LocationService } from '../../shared/services/location.service';
import { LocationSite } from '../../shared/models/location-model/location.model';
import { GeneralService } from '../../shared/services/general.service';
import { TableGeneralComponent } from '../../shared/components-generals/table-general/table-general.component';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-locations',
  imports: [
    CardLocations,
    MatPaginator,
    TableGeneralComponent,
    MatIcon,
    MatButtonModule,
    LoadGeneralComponent,
    TranslateModule,
  ],
  templateUrl: './locations.html',
  styleUrl: './locations.css',
})
export class Locations {
  public isTable = true;
  public isLoading = false;
  public locationSite: LocationSite[] = [];
  public totalLocation = 0;
  public pageIndex = 1;
  public pageSize = 8;
  public Sort = '';
  public SortDir = '';
  public SearchField = '';
  public SearchFieldValue = '';
  private filterSubscription!: Subscription;
  public dataAux: LocationCard[] = [];

  public headersLocations: { description: string; value: string }[] = [];
  public dataSourceLocations = new MatTableDataSource<any>([]);

  constructor(
    public dialog: MatDialog,
    private locationService: LocationService,
    private breakpointObserver: BreakpointObserver,
    private generalService: GeneralService,
  ) {}

  ngOnInit(): void {
    this.filterSubscription = this.generalService.emitFilterLocation
      .pipe(
        distinctUntilChanged((prev, curr) => {
          return (
            prev?.Sort === curr?.Sort &&
            prev?.SortDir === curr?.SortDir &&
            prev?.SearchField === curr?.SearchField &&
            prev?.SearchFieldValue === curr?.SearchFieldValue
          );
        }),
      )
      .subscribe((filterData) => {
        this.Sort = filterData.Sort || '';
        this.SortDir = filterData.SortDir || '';
        this.SearchField = filterData.SearchField || '';
        this.SearchFieldValue = filterData.SearchFieldValue || '';
        this.pageIndex = 1;
        this.getLocations();
      });

    this.getLocations();
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  public onEventLocation(event: { button: ButtonsCard; id: number }) {
    if (event.button.type === 'location') {
      this.openMapGeneral(this.findLocationById(event.id));
    }
    if (event.button.type === 'article') {
      this.generalService.goToUrl(['home'], { statusSelected: 2, locationId: event.id });
    }
  }

  public onEventLocationTable(event: any) {
    console.log('Evento recibido desde la tabla:', event);
    if (event.button.key === 'location') {
      this.openMapGeneral(this.findLocationById(event.item?.Id));
    }
    if (event.button.key === 'article') {
      this.generalService.goToUrl(['home'], { statusSelected: 2, locationId: event.item?.Id });
    }
  }

  public openServicesTable(id: number): void {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 640px)');
    const dialogRef = this.dialog.open(ServicesTable, {
      width: isMobile ? '95vw' : '75vw',
      height: 'auto',
      maxWidth: isMobile ? '95vw' : '75vw',
      maxHeight: isMobile ? '95vh' : '75vh',
      disableClose: true,
      autoFocus: false,
      data: { id },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  public openDetailLocation(id: number): void {
    this.generalService.goToUrl(['detail-location'], { id: id }, true);
  }

  public openMapGeneral(location: LocationSite | undefined): void {
    if (!location) {
      return;
    }
    const isMobile = this.breakpointObserver.isMatched('(max-width: 640px)');
    const dialogRef = this.dialog.open(MapGeneral, {
      width: isMobile ? '95vw' : '75vw',
      height: 'auto',
      maxWidth: isMobile ? '95vw' : '75vw',
      maxHeight: isMobile ? '95vh' : '75vh',
      disableClose: true,
      autoFocus: false,
      data: { location },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  public changeTable(isTable: boolean): void {
    this.isTable = isTable;
  }

  public getLocations(): void {
    this.isLoading = true;
    localStorage.setItem(
      'locationFilters',
      JSON.stringify({
        Sort: this.Sort,
        SortDir: this.SortDir,
        SearchField: this.SearchField,
        SearchFieldValue: this.SearchFieldValue,
      }),
    );
    this.locationService
      .getLocation({
        Page: this.pageIndex,
        PageSize: this.pageSize,
        SearchField: this.SearchField,
        SearchFieldValue: this.SearchFieldValue,
        Sort: this.Sort,
        SortDir: this.SortDir,
        // 'DefaultSearchFields[0].Text': 'RED JALISCO',
        // 'DefaultSearchFields[0].Value': 'Customer',
      })
      .subscribe((response) => {
        if (response) {
          this.locationSite = response.Data.Items;
          this.totalLocation = response.Data.TotalCount;
          // Rellenar dataAux
          this.dataAux = this.locationSite.map((item) => ({
            id: item.Id,
            status: item.Status || '',
            title: item.LocationName || '',
            dataGrid: [
              { description: 'ID', value: item.Key || '' },
              { description: 'Cliente', value: item.Customer || '' },
              {
                description: 'Sitio',
                value: item.Site || '',
              },
              {
                description: 'Zona',
                value: item.Zone || '',
              },
              { description: 'Estatus', value: item.Status || '' },
              { description: 'Prioridad', value: item.Priority || '' },
            ],
            dataColum: [
              {
                description: 'Dirección',
                value: item.Address || '',
              },
            ],
            buttons: [
              { type: 'location', description: 'Ver detalles', icon: 'add_location' },
              { type: 'article', description: 'article', icon: 'add_notes' },
            ],
            textButton: 'Ver detalles',
          }));

          // Rellenar headersLocations dinámicamente si es necesario (opcional, aquí se mantiene igual)
          this.headersLocations = [
            { description: 'ID', value: 'Id' },
            { description: 'Folio', value: 'Key' },
            { description: 'Título', value: 'LocationName' },
            { description: 'Cliente', value: 'Customer' },
            { description: 'Sitio', value: 'Site' },
            { description: 'Zona', value: 'Zone' },
            { description: 'Estatus', value: 'Status' },
            { description: 'Prioridad', value: 'Priority' },
            { description: 'Dirección', value: 'Address' },
          ];

          // Rellenar dataSourceLocations para que coincida con las cards
          this.dataSourceLocations = new MatTableDataSource<any>(
            this.locationSite.map((item: LocationSite) => ({
              Id: item.Id || '',
              Key: item.Key || '',
              LocationName: item.LocationName || '',
              Customer: item.Customer || '',
              Site: item.Site || '',
              Zone: item.Zone || '',
              Status: item.Status || '',
              Address: item.Address || '',
              Priority: item.Priority || '',
            })),
          );
          this.isLoading = false;
        }
      });
  }

  changePage(event: any): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getLocations();
  }

  public findLocationById(id: number): LocationSite | undefined {
    return this.locationSite.find((item) => item.Id === id);
  }
}
